<template>
    <div class="ml-5 mr-5 mt-5"  id="promoterEventLink">
        <v-row>
            <v-col cols="12" class="text-left">
                <h3>{{$t("page.promoterEventLink.promoterEventLink")}}</h3>
                <p class="text-left mb-0">{{ $t("page.promoterEventLink.description_1") }}</p>
            </v-col>
        </v-row> 
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="3" sm="6" class="pb-sm-4 pb-0">
                        <v-autocomplete
                            v-model="selectedPromoter"
                            :items="promoters"
                            item-text="promoterName"
                            item-value="id"
                            :label="$t('page.promoterEventLink.selectPromoter')"
                            outlined dense
                            return-object
                            :no-data-text="$t('common.no_data')"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="9" sm="6" class="d-flex justify-start pt-sm-4 pt-0">
                        <v-btn class="mr-2" color="primary" @click="addLink">{{ $t("page.promoterEventLink.add") }}</v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="4" sm="7" cols="12">
                <v-data-table
                    :headers="headersProm"
                    :items="promotersProm"
                    dense
                    item-key="id" 
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                >
                    <template v-slot:[`item.promoterName`]="{ item }">
                        <span v-html="item.promoterName"></span>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon small class="mr-2" @click="openDelete(item)">fa far fa-trash</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="text-left">
                <h3>{{$t("page.promoterEventLink.eventShownPromoterList")}}</h3>
                <p class="text-left mb-0">{{ $t("page.promoterEventLink.description_2") }}</p>
            </v-col>
        </v-row> 
        <v-row>
            <v-col sm="10" cols="12">
                <v-data-table
                    :headers="headersEvent"
                    :items="eventsPromFiltered"
                    dense
                    item-key="eventId" 
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col md="6" sm="9" cols="12">
                                <v-text-field
                                    v-model="search"
                                    :label="$t('page.promoterEventLink.search')"
                                    class="mx-4"
                                    outlined dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`item.hidden`]="{ item }">
                        <v-checkbox
                            v-model="item.selected"
                            outlined dense
                            class="mt-0 checkEventTable"
                            @change="changeEventHidden($event, item)"
                        ></v-checkbox>
                    </template>
                    <template v-slot:[`item.eventName`]="{ item }">
                        <span v-html="item.eventName"></span>
                    </template>
                    <template v-slot:[`item.promoterName`]="{ item }">
                        <span v-html="item.promoterName"></span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
        @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
        <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
    mixins: [apiCalls],
    components: {
        SGSNotificationConfirm, SGSNotificationAlert
    },
    data() {
        return {
            selectedPromoter: null,
            promoters: [],
            search: '',
            eventsProm: [],
            selectedEvents: [],
            promotersProm: [],
            dialogNotification: false,
            dialogAlert: false,
            alertMessage: '',
            seletedItemDelete: null
        }
    },
    computed: {
        headersProm() {
            return [
                { text: this.$t('page.promoterEventLink.promoter_name'), value: 'promoterNameLink' },
                { text: this.$t('common.delete'), value: 'action' }
            ];
        },
        headersEvent() {
            return [
                { text: this.$t('page.promoterEventLink.hidden'), value: 'hidden' },
                { text: this.$t('page.promoterEventLink.event_id'), value: 'eventId' },
                { text: this.$t('page.promoterEventLink.event_name'), value: 'eventName' },
                { text: this.$t('page.promoterEventLink.promoter'), value: 'promoterName' },
                { text: this.$t('page.promoterEventLink.registration_open'), value: 'registrationOpen' },
                { text: this.$t('page.promoterEventLink.registration_close'), value: 'registrationClose' }

            ];
        },
        ...mapState({
            user: state => state.session.userSession
        }),
        eventsPromFiltered() {
            let events = this.eventsProm;
            if((this.search || "").length > 0) {
                events = events.filter((item) => {
                    return (
                        (item.eventName || "").toString().toLowerCase().match((this.search || "").toString().toLowerCase()) || 
                        (item.promoterName || "").toString().toLowerCase().match((this.search || "").toString().toLowerCase()) || 
                        (item.registrationOpen || "").toString().toLowerCase().match((this.search || "").toString().toLowerCase()) || 
                        (item.registrationClose || "").toString().toLowerCase().match((this.search || "").toString().toLowerCase())
                    );
                })
            }
            return events;
        }
    },
    mounted() {
        this.$store.dispatch('setUser');
        this.getPromoters('unlinked');
        this.getPromoters('linked');
    },
    methods: {
        async getPromoters(type = 'linked') {
            const response = await this.getApi(`/api/v1/promoter/series/eventlink/promoter/${type}`);
            
            if(response && Array.isArray(response)) {
                if(type == 'linked') {
                    this.promotersProm = response;
                    this.getEvents();
                } else {
                    this.promoters = response.map((el) => {
                        return {
                            ...el,
                            promoterName: this.$escapeHtml.decode(el.promoterName)
                        };
                    });
                } 
            }
        },
        async addLink() {
            if(this.selectedPromoter) {
                const response = await this.api(
                    "post",
                    '/api/v1/promoter/series/eventlink/promoter', 
                    { promoterId: this.selectedPromoter.userId }
                );
                if(response.success) {
                    this.getPromoters('unlinked');
                    this.getPromoters();
                } else {
                    this.dialogAlert = true;
                    this.alertMessage = this.$t(`page.promoterEventLink.error.${response.message}`);
                }
            }
            
        },
        openDelete(item) {
            this.selectedItemDelete = item;
            this.dialogNotification = true;
        },
        async deleteItem() {
            if(this.selectedItemDelete) {
                const response = await this.api("delete", `/api/v1/promoter/series/eventlink/promoter/${this.selectedItemDelete.id}`);
                if(response.success) {
                    this.getPromoters('unlinked');
                    this.getPromoters();
                    this.dialogNotification = false;
                }
            }
        },
        closeAlert() {
            this.dialogAlert = false;
        },
        async getEvents() {
            const response = await this.getApi('/api/v1/promoter/series/eventlink/event');
            if(response && Array.isArray(response)) {
                this.eventsProm = response.map((item) => {
                    return {
                        ...item,
                        selected: item.countEvents > 0 
                    }
                });
            }
        },
        async changeEventHidden(newValue, item) {
            if(newValue) { 
                const response = await this.api(
                    "post",
                    '/api/v1/promoter/series/eventlink/event', 
                    { eventId: item.eventId, promoterLinkId: item.promoterLinkId}
                );
                this.getEvents(); 
                if(!response.success) {
                    this.dialogAlert = true;
                    this.alertMessage = this.$t(`page.promoterEventLink.${response.message}`);
                }
            } else {
                const response = await this.api(
                    "delete",
                    '/api/v1/promoter/series/eventlink/event',
                    { eventId: item.eventId, promoterLinkId: item.promoterLinkId}
                );
                this.getEvents();
                if(!response.success) {
                    this.dialogAlert = true;
                    this.alertMessage = this.$t(`page.promoterEventLink.${response.message}`);
                }
            }
        }
    }
}
</script>

<style scss>
.checkEventTable .v-messages {
    display: none;
}
@media (min-width: 1024px) {
  .breadcrumb-c{display: none !important;}
}
</style>